import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteVehicle($companyId: ID!, $id: ID!) {
    deleteVehicle(companyId: $companyId, id: $id) {
       vehicle {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
